import { autobind } from 'frontools/decorators/Autobind';
import VanillaUtils from 'frontools/utils/VanillaUtils';
export class Tile {

    private static _MAX_ROTATION        : number = 5;
    private static _MAX_TRANSLATION     : number = 2;
    private static _PERSPECTIVE_AMOUNT  : number = 1200;

    private _stackingArray              : NodeListOf<HTMLElement>;

    private _width      : number;
    private _height     : number;
    private _offset     : any;

    private _elTile     : HTMLElement;

    constructor(private _elWrapper: HTMLElement) {
        this._elTile = this._elWrapper.querySelector('[data-stacking-factor]') as HTMLElement;

        // this._stackingFactor = parseInt(this._elTile.getAttribute('data-stacking-factor')); 

        this._stackingArray = this._elWrapper.querySelectorAll('[data-stacking-factor]') as NodeListOf<HTMLElement>;

        // this._onResize();
        // window.addEventListener('resize', this._onResize);

        this._elWrapper.addEventListener('mousemove', this._onMouseMove);
        this._elWrapper.addEventListener('mouseleave', this._onMouseLeave);
    }

    /** 
     * 
     * @param e Mousemove event
     */
    @autobind
    private _onMouseMove(e) {
        this._width = this._elTile.offsetWidth;
        this._height = this._elTile.offsetHeight;
        this._offset = VanillaUtils.getOffsetRect(this._elTile);

        var mouseOffsetInside = {
            x : e.pageX - this._offset.left,    
            y : e.pageY - this._offset.top
        };

        var xRotationPercentage = this._calculateTransformPercentage(mouseOffsetInside.y, this._height);
        var yRotationPercentage = this._calculateTransformPercentage(mouseOffsetInside.x, this._width) * -1;
        var xTranslationPercentage = this._calculateTransformPercentage(mouseOffsetInside.x, this._width);
        var yTranslationPercentage = this._calculateTransformPercentage(mouseOffsetInside.y, this._height);

        for (let i =0; i< this._stackingArray.length; i++) {
            this._animate(this._stackingArray[i], {
                xRotationPercentage : xRotationPercentage,
                yRotationPercentage : yRotationPercentage,
                xTranslationPercentage : xTranslationPercentage,
                yTranslationPercentage : yTranslationPercentage,
                stackingFactor: parseInt(this._stackingArray[i].getAttribute('data-stacking-factor'))
            })
        }
    }

    /**
     * 
     * @param e Mouseleave event
     */
    @autobind
    private _onMouseLeave() {
        for (let i =0; i< this._stackingArray.length; i++) {
            TweenMax.to(this._stackingArray[i], 0.4, {
                transformPerspective: Tile._PERSPECTIVE_AMOUNT, 
                rotationX:  "0deg",
                rotationY: "0deg",
                x:  0,
                y:  0,
                z : 0,
            });
        }
    }

    // @autobind
    // private _onResize() {
        
    // }

    private _calculateTransformPercentage(offset, dimension) {
        return ((-2 / dimension) * offset) + 1;
    }

    /**
     * Animate tile 
     * @param config 
     */
    private _animate(el: HTMLElement, config: TransformConfig) {
        TweenMax.to(el, 0.2, {
            transformPerspective: Tile._PERSPECTIVE_AMOUNT, 
            rotationX:  config.xRotationPercentage * Tile._MAX_ROTATION +"deg",
            rotationY: config.yRotationPercentage * Tile. _MAX_ROTATION +"deg",
            x:  config.xTranslationPercentage * Tile._MAX_TRANSLATION * config.stackingFactor,  
            y: config.yTranslationPercentage * Tile._MAX_TRANSLATION * config.stackingFactor,
            z : "0px",
        });
    }

    public destroy() {
        // window.removeEventListener('resize', this._onResize);
        this._elWrapper.removeEventListener('mousemove', this._onMouseMove);
        this._elWrapper.removeEventListener('mouseleave', this._onMouseLeave);
        this._onMouseLeave();
    }

}

interface TransformConfig {
    xRotationPercentage : number,
    yRotationPercentage : number,
    xTranslationPercentage : number,
    yTranslationPercentage : number,
    stackingFactor : number,
}